
// Import vendor modules.
import Alpine from "@alpinejs/csp";
import htmx from "htmx.org";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

Alpine.data( "r08qml_CommentForm", CommentForm );

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

function CommentForm() {

	return {
		previewTimer: null,
		author: null,
		comment: null,
		commentPreview: null,

		init,
		destroy,
		insertEmoji,
		requestPreview,
	};

	// ---
	// LIFE-CYCLE METHODS.
	// ---

	function init() {

		this.author = this.$el.querySelector( "[data-author]" ) ?? null;
		this.comment = this.$el.querySelector( "[data-comment-content]" );

	}


	function destroy() {

		clearTimeout( this.previewTimer );

	}

	// ---
	// PUBLIC METHODS.
	// ---

	/**
	* I insert the given emoji (contained within the event) into the comment text.
	*/
	function insertEmoji( event ) {

		var glyph = event.detail.emoji;
		var value = this.comment.value;
		var insertAt = this.comment.selectionEnd;
		var nextSelectionAt = ( insertAt + glyph.length );

		this.comment.value = (
			value.slice( 0, insertAt ) +
			glyph +
			value.slice( insertAt )
		);
		this.comment.selectionStart = nextSelectionAt;
		this.comment.selectionEnd = nextSelectionAt;
		this.comment.focus();

		this.requestPreview( event );

	}


	/**
	* I request a preview of the current comment markup.
	*/
	function requestPreview( event ) {

		clearTimeout( this.previewTimer );
		this.previewTimer = setTimeout(
			async () => {

				// Passing the email through (if it exists) for error log insight.
				var authorEmail = ( this.author?.value ?? "" );
				var content = this.comment.value;

				await htmx.ajax(
					"POST",
					"/blog/comment/preview.htm",
					{
						select: ".m-comment-preview",
						target: "[data-comment-preview]",
						swap: "innerHTML",
						values: {
							authorEmail,
							content,
						},
					}
				);

			},
			300
		);

	}

}
